<template>
  <section id="delivery-instructions">
    <router-link id="link_delivery-instructions_stop" v-if="isStopAndReturnable()" to="/delivery-enquiry/instructions/stop">Stop & return the parcel</router-link>
    <router-link id="link_delivery-instructions_provide-access" to="/delivery-enquiry/instructions/provide-access">Provide address/access instructions or directions</router-link>
    <router-link id="link_delivery-instructions_safe-place" to="/delivery-enquiry/instructions/safe-place">Update my safe place location or a neighbour</router-link>
    <router-link id="link_delivery-instructions_wrong-number" to="/delivery-enquiry/instructions/wrong-number">My house number or name is wrong</router-link>
    <router-view></router-view>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      tracking: state => state.tracking
    })
  },
  methods: {
    isStopAndReturnable() {
      return ['2', '3', '4', '6'].indexOf(this.tracking.stage) !== -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/DeliveryInstructions.vue